import { YearSelect, MonthSelect } from '../types/common/EstimationType';

// 当年以降の11年分のリスト取得
export const getYearList = () => {
    const year = new Date().getFullYear();
    const formattedYear = (y: number) => y.toString() + '年';

    const baseYearList: Array<YearSelect> = Array(11)
        .fill(null)
        .map(() => {
            return { value: '', caption: '', firstFlg: false };
        });
    const yearList: Array<YearSelect> = baseYearList.map((by, i) => {
        const incrementYear = year + i;
        by.value = incrementYear.toString();
        by.caption = formattedYear(incrementYear);
        if (i < 6) by.firstFlg = true;
        return by;
    });

    return yearList;
};

// 月リスト作成
export const getMonthList = () => {
    const monthList: Array<MonthSelect> = [];
    // 当年
    const thisYear = new Date().getFullYear();
    // 当月
    const thisMonth = new Date().getMonth() + 1;
    for (let i = 0; i < 12; i++) {
        const value = `${i + 1}`;
        const caption = `${i + 1}月`;
        monthList.push({ value, caption, thisYear, thisMonth });
    }

    return monthList;
};

// 月表示の非活性判定
export const monthDisabledCheck = (thisYear: string, selectedYear: string, thisMonth: number, month: number) => {
    let disableFlg = false;
    const checkYear = selectedYear !== '' && selectedYear !== undefined ? selectedYear : thisYear;
    // 選択年月と当年が同一であるかつ、当月より該当レコード月が小さい
    if (thisYear === checkYear && thisMonth >= month) {
        disableFlg = true;
    }

    return disableFlg;
};

// 保守期間年月初期値取得
export const getMainteDefault = () => {
    // 開始年月：現在の2ヵ月後を設定
    const startDate = new Date();
    startDate.setMonth(startDate.getMonth() + 2);

    // 終了年月：開始年月の1年後を設定する
    const endDate = new Date(startDate);
    endDate.setFullYear(endDate.getFullYear() + 1);
    endDate.setMonth(endDate.getMonth() - 1);

    return [startDate, endDate];
};

// 保守期間の計算
export const culcTerm = (startYear: string, startMonth: string, endYear: string, endMonth: string) => {
    let culcYear = 0;
    let culcMonth = 0;
    if ([startYear, startMonth, endYear, endMonth].every((v) => v !== '')) {
        const start = Number(startYear) * 12 + Number(startMonth);
        const end = Number(endYear) * 12 + Number(endMonth);

        const diffMonth = end - start + 1;
        if (diffMonth > 0) {
            culcYear = (diffMonth / 12) | 0;
            culcMonth = diffMonth % 12;
        }
    }

    return `${culcYear}年 ${culcMonth}ヵ月`;
};
